// third-party

import { NavItemType } from "types";

import * as RouteHelper from "@utils/routes";

import Business from "@mui/icons-material/Business";
import TrackChanges from "@mui/icons-material/TrackChanges";
import { useTheme } from "@mui/material";

// ==============================|| APPLICATION MENU ITEMS ||============================== //

export const getDirectoryNav = (projectId: string): NavItemType => {
  const theme = useTheme();
  return {
    id: "directory",
    title: "Discover",
    icon: <TrackChanges sx={{ color: theme.palette.primary.main }} />,
    type: "group",
    children: [
      {
        id: "companies",
        title: "Smart Directory",
        type: "item",
        icon: <Business style={{ color: theme.palette.primary.main }} />,
        url: RouteHelper.directory(projectId),
      },
    ],
  };
};
